$(document).ready(function() {
    $("li:first-child").addClass("first");
    $("li:last-child").addClass("last");
    $('[href="#"]').attr("href", "javascript:;");
    $('.menu-Bar').click(function() {
        $(this).toggleClass('open');
        $('.menuWrap').toggleClass('open');
        $('body').toggleClass('ovr-hiddn');
    });

    $('.loginUp').click(function(){
        $('.LoginPopup').fadeIn();
        $('.overlay').fadeIn();
    });

    $('.signUp').click(function(){
        $('.signUpPop').fadeIn();
        $('.overlay').fadeIn();
    });

     $('.closePop,.overlay').click(function(){
        $('.popupMain').fadeOut();
        $('.overlay').fadeOut();
    });

});


// Fancy Media
$('.fancybox-media').fancybox({
    openEffect: 'none',
    closeEffect: 'none',
    helpers: {
        media: {}
    }
});


// Slider For
$('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    fade: true,
    asNavFor: '.slider-nav'
});
$('.slider-nav').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.slider-for',
    dots: false,
    focusOnSelect: true
});


// Accordion
$('.myaccordi>li').click(function() {
    $(this).addClass('active');
    $(this).siblings().removeClass('active');
});
//  https://www.w3schools.com/howto/tryit.asp?filename=tryhow_js_accordion

$(window).scroll(function() {
    var scroll = $(window).scrollTop();
    if (scroll >= 100) {
        $(".okash").addClass("sticky-header");
    } else {
        $(".okash").removeClass("sticky-header");
    }
});
// Sticky Navigation
$(window).scroll(function() {
    var scroll = $(window).scrollTop();
    if (scroll >= 200) {
        $(".fixed").addClass("sticky");
    } else {
        $(".fixed").removeClass("sticky");
    }
});


// Normal Slider
$('.feat-slide').slick({
  dots: true,
  arrows: true,
  infinite: true,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2, 
        slidesToScroll: 1,
        dots: true
      }
    },
    {
      breakpoint: 600, 
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: true
      }
    }
  ]
});

$('.testimonial-slider').slick({
    infinite: true,           
    slidesToShow: 3,          
    slidesToScroll: 1,        
    arrows: true,             
    dots: true,               
    autoplay: true,           
    autoplaySpeed: 8000,      
      responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2, 
        slidesToScroll: 1,
        dots: true
      }
    },
    {
      breakpoint: 600, 
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: true
      }
    }
  ]
});      


// Navigation Menu 
$(window).on('load', function() {
var currentUrl = window.location.href.substr(window.location.href.lastIndexOf("/") + 1);
$('ul.menu li a').each(function() {
    var hrefVal = $(this).attr('href');
    if (hrefVal == currentUrl) {
        $(this).removeClass('active');
        $(this).closest('li').addClass('active')
        $('ul.menu li.first').removeClass('active');
    }
});

});

// Tabbing JS
  $('[data-targetit]').on('click', function(e) {
  $(this).addClass('current');
  $(this).siblings().removeClass('current');
  var target = $(this).data('targetit');
  $('.' + target).siblings('[class^="box-"]').hide();
  $('.' + target).fadeIn();
  $(".tab-slider").slick("setPosition");
});

/* RESPONSIVE JS */

const counters = document.querySelectorAll('.counter');
let started = false;

const startCounter = () => {
    counters.forEach(counter => {
        const target = +counter.getAttribute('data-target');
        let count = 0;

        const updateCount = () => {
            const speed = 70;
            const increment = target / speed;

            if (count < target) {
                count += increment;

                if (target < 10) {
                    counter.innerText = count.toFixed(1);
                } else {
                    counter.innerText = Math.floor(count);
                }

                requestAnimationFrame(updateCount);
            } else {
                counter.innerText = target;

                // special formatting
                if (target === 98) counter.innerText = "98%";
                if (target === 400) counter.innerText = "400+";
            }
        };

        updateCount();
    });
};

// Scroll Trigger
const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
        if (entry.isIntersecting && !started) {
            startCounter();
            started = true;
        }
    });
}, { threshold: 0.5 });

observer.observe(document.querySelector('#counterSection'));

if ($(window).width() < 825) {
}


// Lenis smooth scroll
// 2026-10-03: desktop (fine pointer) only. Phones and tablets keep native scroll.
// Also skips cleanly when the async Lenis script has not loaded yet, instead of throwing.
let lenis = null;
if (typeof window.Lenis === 'function' && !window.matchMedia('(pointer: coarse)').matches) {
    lenis = new Lenis({
      duration: 1.9,           // animation duration (seconds)
      easing: t => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // easing
      smooth: true,
      direction: 'vertical',
      mouseMultiplier: 1,
      smoothTouch: false,
      touchMultiplier: 2,
      infinite: false,
      anchors: true
    });

    // RAF loop to drive Lenis
    const lenisRaf = (time) => {
      lenis.raf(time);
      requestAnimationFrame(lenisRaf);
    };
    requestAnimationFrame(lenisRaf);
}

// Header anchors: smooth via Lenis when it is running, otherwise native behaviour
document.querySelectorAll('a.anchor').forEach(a => {
  a.addEventListener('click', (e) => {
    if (!lenis) return;
    const href = a.getAttribute('href');
    if (!href || !href.startsWith('#')) return;
    const target = document.getElementById(href.slice(1));
    if (!target) return;
    e.preventDefault();
    const header = document.querySelector('header');
    const headerOffset = header ? header.offsetHeight : 0;
    const top = target.getBoundingClientRect().top + window.scrollY - headerOffset;
    lenis.scrollTo(top, { duration: 1.2, easing: (t) => t });
  });
});
